import React, { useEffect, useState } from 'react';
import axios from 'axios';


function TimesheetTab({ caseId }) {
  const [entries, setEntries] = useState([]);

  // Fetch timesheets for a specific Project
  const fetchEntries = async () => {
    const token = localStorage.getItem("token");

    try {
      const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/timesheets/case/${caseId}`,{
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      });
      setEntries(res.data);
    } catch (err) {
      console.error('Error fetching timesheets:', err);
    }
  };

  // Run on mount or when caseId changes
  useEffect(() => {
    if (caseId) fetchEntries();
  }, [caseId]);


  return (
    <div className="space-y-4">
   
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        {entries.map((entries) => (
          <div
            key={entries._id}
            className="bg-white p-4 border rounded shadow flex justify-between items-start"
          >
            <div>
              <p><strong>Task:</strong> {new Date(entries.task).toLocaleDateString()}</p>
              <p><strong>Duration :</strong> {entries.duration}</p>
              <p><strong>Notes:</strong> {entries.notes || '—'}</p>
            </div>
           
          </div>
        ))}
      </div>

      
    </div>
  );
}

export default TimesheetTab;
